module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "tochead"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "id": "a7"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "ncx42"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter_1#a24"
    }
  }, [_vm._v("Author’s Notes and Acknowledgements")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "ncx43"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter_2#a25"
    }
  }, [_vm._v("Profiles")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "ncx44"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter_3#a26"
    }
  }, [_vm._v("C Squadron SAS")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "ncx45"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter_4#a27"
    }
  }, [_vm._v("Rebuilding")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "ncx46"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter_5#a28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Escape and Evasion")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "ncx47"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter_6#a29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Getting the Boot")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "ncx48"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter_7#a30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ghosts of Angola")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "ncx49"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter_8#a31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Haunting the MPLA")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "ncx50"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter_9#a32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Relentless Pursuit")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "ncx51"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter_10#a33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Anguish of an SAS General")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "ncx52"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter_11#a34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The British Reply to General Wall’s Letter")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "ncx53"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter_12#a35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Tribute to General Peter Walls")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "ncx54"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter_13#a36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("South Africa’s Zimbabwe Flop")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "ncx55"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter_14#a37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Renamo Gather Steam")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "ncx56"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter_15#a38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Assassination of Samora Machel?")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "ncx57"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter_16#a39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Grahams of Burnley")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 69
// module chunks = 0